import { AdminTableRowProps } from './admin-table-row-props';
import React from 'react';
import { TableRow } from '@mint/ui';

export const AdminTableRow: React.FunctionComponent<
  AdminTableRowProps
> = TableRow;
